<template>
  <!-- 邮局赠礼 -->
  <div class="post-enter" @click="jumpToPostOffice">
    <img src="../../../../ui/assets/mobile/images/my-backpack.png" alt="" />
  </div>
</template>
<script>
import { CLICK } from "../../../constants/report-dictonary"
import { ZQ_DETAIL_ENTER } from "../../../constants/pf-structure"
import Vue from "vue"
import * as errorMaps from "@constants/error_map"
import * as ua from "@utils/ua"

export default {
  props: ["pf", "currentItem", "selectAccount", "checkThirdSession", "checkUserIsBindAccount", "invalidSession", "openZoneAndRoleSelector"],
  setup(props, { root }) {
    const userAgent = ua.getUserAgent()
    const jumpToPostOffice = () => {
      if (!props.checkUserIsBindAccount || props.invalidSession) {
        // 第三方登录态拉起绑定后才可进入
        if (userAgent.kuaishou || userAgent.huya) {
          Vue.$SelectAccountPrompt({
            selectAccount: props.selectAccount
          }).show()
        } else {
          Vue.$Toast({ toastMsg: errorMaps.USER_HELPER.THIRD_INVALID_SESSION })
        }
        return
      } else if (props.checkThirdSession && props.checkUserIsBindAccount) {
        props.openZoneAndRoleSelector()
        return
      }

      root.$router.push({
        path: `/backpack/${props.currentItem.groupId}/biz/${props.currentItem.busId}`,
        query: {
          pfStructure: ZQ_DETAIL_ENTER
        }
      })

      root.$store.dispatch("reportUserAction", {
        iformat: CLICK.REDEEM_ICON_POST_OFFICE
      })
    }

    return {
      jumpToPostOffice
    }
  }
}
</script>
